import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-background border-t border-slate-200/60 py-12 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <div>
            <h4 className="text-lg font-semibold text-text-primary mb-3">Amada Technology</h4>
            <p className="text-base text-text-secondary leading-7 mb-4">
              A technology company delivering technical consulting, systems implementation, and workflow automation.
            </p>
            <div className="space-y-2 text-sm text-text-secondary">
              <p>United States</p>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-text-primary mb-4 uppercase tracking-wider">Contact</h4>
            <div className="space-y-3">
              <a 
                href="https://www.linkedin.com/company/amada-technology" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block text-text-secondary hover:text-accent transition-colors"
                aria-label="LinkedIn"
              >
                <svg 
                  className="w-6 h-6" 
                  fill="currentColor" 
                  viewBox="0 0 24 24" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-slate-200/60 pt-8">
          <p className="text-sm text-text-secondary">
            © 2024 Amada Technology. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
